import { collection, getDocs, query, where } from "firebase/firestore";
import React from "react";
import { db } from "../../firebase";

const CheckRegistrationNoExists = (RegNo, SchoolID) => {
  if (RegNo && SchoolID) {
    const UserRef = collection(db, "Users");

    const q = query(
      UserRef,
      where("SchoolID", "==", SchoolID),
      where("UserType", "==", "student"),
      where("AdditionalDetails.StudentRegistrationNo", "==", RegNo)
    );

    return getDocs(q).then((querySnapshot) => {
      return querySnapshot.size;
    });
  }
};

export default CheckRegistrationNoExists;
